import { createTheme, ThemeOptions } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { deepOrange } from "@mui/material/colors";

const baseTheme = createTheme();

const customThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#1976d2", // Cor principal
      light: "#4791db",
      dark: "#115293",
    },
    secondary: {
      main: deepOrange["500"], // Cor secundária
      light: deepOrange["300"],
      dark: deepOrange["900"],
    },
    uv_primary: {
      main: "#1976d2", // Cor principal
      light: "#4791db",
      dark: "#115293",
    },
    uv_secondary: {
      main: "#ff6511", // Cor principal
      light: "#ff8d18",
      dark: "#cc510e",
    },
    background: {
      default: "#f4f6f8", // Cor de fundo padrão
      paper: "#ffffff", // Cor de fundo dos componentes
    },
    // Customize outras cores conforme necessário, como `error`, `info`, `success`, etc.
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    // Personalize outras configurações de tipografia conforme necessário.
  },
};

const customTheme = deepmerge(baseTheme, customThemeOptions);

export default customTheme;
